












import Vue from 'vue'
import BusinessCardModel from '@/calendesk/models/BusinessCardModel'
import BusinessCard from '@/views/components/creator/BusinessCard.vue'
import { BusinessType } from '@/calendesk/models/BuilderTypes'

// Display order only: drafts keep the type's id. Therapy, health and professional services come
// first, then education, fitness and venues, beauty near the end and "Other" last.
const displayOrder: BusinessType[] = [
  BusinessType.BUSINESS_15, // psychologist
  BusinessType.BUSINESS_29, // physiotherapy
  BusinessType.BUSINESS_12, // medicine
  BusinessType.BUSINESS_4, // dietitian
  BusinessType.BUSINESS_11, // legal services
  BusinessType.BUSINESS_16, // consulting
  BusinessType.BUSINESS_17, // coaching
  BusinessType.BUSINESS_9, // financial services
  BusinessType.BUSINESS_5, // private lessons
  BusinessType.BUSINESS_22, // personal trainer
  BusinessType.BUSINESS_24, // fitness
  BusinessType.BUSINESS_25, // yoga
  BusinessType.BUSINESS_23, // gym
  BusinessType.BUSINESS_21, // sport
  BusinessType.BUSINESS_26, // tennis club
  BusinessType.BUSINESS_27, // meeting facilities
  BusinessType.BUSINESS_7, // business events
  BusinessType.BUSINESS_13, // driving school
  BusinessType.BUSINESS_14, // photographer
  BusinessType.BUSINESS_19, // architecture / interior design
  BusinessType.BUSINESS_6, // child care
  BusinessType.BUSINESS_18, // animal care
  BusinessType.BUSINESS_20, // cleaning services
  BusinessType.BUSINESS_8, // city hall
  BusinessType.BUSINESS_10, // escape room
  BusinessType.BUSINESS_28, // restaurant
  BusinessType.BUSINESS_2, // spa
  BusinessType.BUSINESS_3, // beauty salon
  BusinessType.BUSINESS_1, // hairdressing salon
  BusinessType.BUSINESS_30 // other
]

export default Vue.extend({
  name: 'SelectBusiness',
  components: {
    BusinessCard
  },
  data () {
    return {
      businessCards: [] as Array<BusinessCardModel>
    }
  },
  mounted () {
    this.generateCards()
  },
  methods: {
    generateCards () {
      this.businessCards = displayOrder.map(id =>
        new BusinessCardModel(id, require('@/assets/business_' + id + '.jpg'), this.$trans('wb_business_' + id))
      )
    }
  }
})
